import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ObservableBackendService} from './observableBackend.service';
import {UserCredentials} from '../domain/userCredentials';
import {User} from '../domain/user';
import {MyRequestOptions} from '../my.request.options';
import {URLSearchParams} from "@angular/http";

@Injectable()
export class LoginService {

    private loginUrl = 'login';
    private loginClientUrl = 'clientLogin';
    private loginOut = 'logout';
    private userLoggedSubject:Subject<User> = new Subject<User>();
    private userLogged:User;

    constructor(private backendService:ObservableBackendService) {
        this.userLoggedSubject = new Subject<User>();
    }

    public authenticate(data:UserCredentials):Observable<UserCredentials> {
        this.userLogged = null;
        let creds = "username=" + data.username + "&password=" + data.password;
        let headers = new MyRequestOptions();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.backendService.post(this.loginUrl, creds, headers);
    }

    public authenticateClient(data:UserCredentials):Observable<UserCredentials> {
        this.userLogged = null;
        data.isPatent = !data.isCuit;
        return this.backendService.post(this.loginClientUrl, data, null);
    }

    public getUserCredentials(bankId:String = null):Observable<User> {
        let params:any = null;
        if(bankId){
            params = new URLSearchParams();
            params.set('bankId', String(bankId));
        }
        return this.backendService.get("getUserLoggedIn", params);
    }

    public getUserCredentialsByBank(bankId:String):Observable<User> {
        let params = new URLSearchParams();
        params.set('bankId', String(bankId));
        return this.backendService.get("getUserLoggedInByBankId", params);
    }

    public setUserLogged(userLogged:User):void {
        this.userLogged = userLogged;
        if (this.userLoggedSubject) {
            this.userLoggedSubject.next(userLogged);
        }
    }

    public getUserLogged():User {
        return this.userLogged;
    }

    public getUserLoggedSubject():Subject<User> {
        if (!this.userLoggedSubject) {
            this.userLoggedSubject = new Subject<User>()
        }
        return this.userLoggedSubject;
    }

    public logout():Observable<any> {
        return this.backendService.post(this.loginOut, null, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/login.service.ts
 **/